// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"00a18b45","49":"1496396b","283":"5644ac40","291":"25fc4576","641":"d9264a6e","676":"2560904a","737":"4d69da60","798":"1ee6ea48","987":"08abf68f"}[chunkId] + ".chunk.js";
};